import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { getValidToken } from "../../../utils/tokenManager";

/**
 * Extracted from admin/Client.jsx - same fetch, same date formatting
 * (Colombia timezone), same attendance-update endpoint/payload.
 */
export function useScheduledMeetings() {
  const { t } = useTranslation();
  const [meetings, setMeetings] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const fetchMeetings = async () => {
    try {
      const accessToken = await getValidToken();
      const response = await axios.get(`${process.env.REACT_APP_APIBASEURL}/api/meetings/all`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      const mappedData = response.data.meetingLogs.map((meeting) => {
        const meetingDate = moment.utc(meeting.Date).tz("America/Bogota");
        return {
          contactId: meeting.ContactId,
          meetingLogId: meeting.Id,
          originalDate: meeting.Date,
          date: meetingDate.format("MMM DD"),
          time: meetingDate.format("h:mmA"),
          name: meeting.Name,
          lastName: meeting.Lastname,
          company: meeting.Company,
          mail: meeting.Email,
          phone: meeting.Phone,
          attended: meeting.Attend === true ? "Yes" : meeting.Attend === false ? "No" : "",
          attempt: meeting.Num_intent || 0,
        };
      });

      setMeetings(mappedData);
    } catch (error) {
      console.error("Error fetching meetings:", error);
    }
  };

  useEffect(() => {
    fetchMeetings();
  }, []);

  const updateAttendance = async (meetingLogId, attendedValue) => {
    try {
      const accessToken = await getValidToken();
      await axios.put(
        `${process.env.REACT_APP_APIBASEURL}/api/meetings/log/${meetingLogId}`,
        { Attend: attendedValue === "Yes" },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      setMeetings((prev) =>
        prev.map((m) => (m.meetingLogId === meetingLogId ? { ...m, attended: attendedValue } : m))
      );
      return true;
    } catch (error) {
      const errorMessage = error.response?.data?.error || t("error.generic");
      setErrorModal(true);
      setErrors({ submit: errorMessage });
      return false;
    }
  };

  const filteredMeetings = meetings.filter((m) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      (m.name || "").toLowerCase().includes(term) ||
      (m.company || "").toLowerCase().includes(term) ||
      (m.mail || "").toLowerCase().includes(term)
    );
  });

  return {
    meetings: filteredMeetings,
    searchTerm,
    setSearchTerm,
    errorModal,
    setErrorModal,
    errors,
    updateAttendance,
  };
}